// src/components/auth/ProtectedRoute.tsx
import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { getSelectedServer } from '../../utils/serverUtils';

interface ProtectedRouteProps {
    children: React.ReactNode;
    /**
     * Whether the page needs a chosen world. True for everything in the game, false for the
     * selection page itself — which is the page a signed-in player without a world is sent
     * to, so requiring one there would be a redirect loop.
     */
    requireWorld?: boolean;
}

/**
 * Two gates, not one.
 *
 * Signing in gets an account; it does not decide which world that account is playing. Every
 * game page reads its data from one world, so arriving at one without having chosen would
 * quietly fall back to beta — which is exactly what happened before world selection had a
 * page of its own.
 */
export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children, requireWorld = true }) => {
    const { currentUser } = useAuth();

    if (!currentUser) return <Navigate to="/" replace />;
    if (requireWorld && !getSelectedServer()) return <Navigate to="/worlds" replace />;

    return <>{children}</>;
};
